import { Button } from '../primitives/button.js'
import { graphHooks } from '@tunasong/graph-lib/react'
import { useContentViews } from '@tunasong/plugin-lib'
import type { Entity, Persisted } from '@tunasong/schemas'
import type { FC } from 'react'
import invariant from 'tiny-invariant'
import { ButtonGroup } from '../primitives/index.js'
import moduleStyles from './content-views.module.css'

export interface ContentViewsProps {
  entity?: Persisted<Entity>
}

export const ContentViews: FC<ContentViewsProps> = props => {
  const { entity } = props
  const contentViews = useContentViews(entity)

  const currentView = entity?.options?.activeView
  const activeView = currentView ? currentView : contentViews[0]
  const updateEntity = graphHooks.useEntityUpdate<Entity>()
  const handleView = (view: string) => () => {
    invariant(entity, 'Entity must be defined')
    updateEntity(entity.id, { options: { ...entity.options, activeView: view } })
  }

  return (
    <ButtonGroup>
      {contentViews.map(view => (
        <Button
          tabIndex={-1}
          key={view}
          disabled={activeView === view}
          className={moduleStyles.viewButton}
          onClick={handleView(view)}
        >
          {view}
        </Button>
      ))}
    </ButtonGroup>
  )
}

export default ContentViews
